import { TsDOM as q} from '@/scripts/core/TsDOM'
import { MarqueeSlider } from '@/scripts/theme/marquee-slider';
q.safeDefineElement(MarqueeSlider)